import { useFormContext } from 'react-hook-form';
import { FormValues } from './schema';
import { useEffect } from 'react';
import Big from 'big.js';

export function useSyncTokenPrice(price: number | null) {
  const { setValue, watch } = useFormContext<FormValues>();
  const formCurrentPrice = watch('currentTokenPrice');

  useEffect(() => {
    if (price && !Big(price).eq(formCurrentPrice || 0)) {
      setValue('currentTokenPrice', price);
    }
  }, [price, formCurrentPrice]);
}
